export const faqList = [
  {
    question: '虫虫漫画上的漫画都是正版授权的吗？',
    answer: '是的，虫虫漫画平台上的所有漫画作品均已获得正版授权。我们与韩国多家知名漫画工作室和出版社建立了长期合作关系，确保每一位读者都能阅读到高质量的正版漫画内容，同时也为创作者提供合理的收益回报。',
  },
  {
    question: '如何注册成为虫虫漫画的会员？',
    answer: '注册非常简单！点击页面右上角的"注册"按钮，使用您的手机号或电子邮箱即可完成注册。注册后您将获得免费阅读部分章节的权限，还可以收藏喜欢的漫画、订阅更新通知，享受更完整的阅读体验。',
  },
  {
    question: '漫画的更新频率是怎样的？',
    answer: '大部分热门连载漫画保持每周更新的频率，通常在每周五至周日之间更新新章节。部分高人气作品可能会达到每周两更。您可以在每部漫画的详情页查看具体的更新计划，也可以通过订阅功能第一时间收到更新提醒。',
  },
  {
    question: '可以在手机和平板上阅读吗？',
    answer: '当然可以！虫虫漫画采用响应式设计，完美适配手机、平板和电脑等多种设备。无论您使用哪种设备，都能获得流畅舒适的阅读体验。我们特别优化了移动端的竖屏阅读模式，让您在手机上也能享受沉浸式的漫画阅读。',
  },
  {
    question: '漫画的翻译质量如何保证？',
    answer: '我们拥有一支专业的韩语翻译团队，所有译者均具有丰富的漫画翻译经验。每部作品的翻译都经过初译、校对、润色三道工序，确保在准确传达原文意思的同时，保留韩语漫画独特的语言风格和文化韵味。',
  },
  {
    question: '如何联系客服解决问题？',
    answer: '您可以通过以下方式联系我们：发送邮件至 support@chongchongmanga.com，或在网站底部的"联系我们"板块提交反馈。我们的客服团队工作时间为周一至周日 9:00-21:00，通常会在2小时内回复您的问题。',
  },
  {
    question: '虫虫漫画有付费内容吗？',
    answer: '虫虫漫画采用"免费+付费"的混合模式。每部漫画的前10-20章通常可以免费阅读，后续章节需要使用阅读券或会员订阅解锁。我们提供多种灵活的付费方案，包括单部购买、月度会员和年度会员，满足不同读者的需求。',
  },
];

export const testimonials = [
  {
    id: 1,
    name: '小雨',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20anime%20style%20female%20avatar%20portrait%20with%20warm%20smile%2C%20soft%20illustration%20style%2C%20clean%20minimal%20background&width=80&height=80&seq=avatar-01&orientation=squarish',
    role: '资深漫画迷',
    content: '虫虫漫画的翻译质量真的太棒了！之前看英文翻译总觉得少了味道，中文版完美还原了韩漫的细腻情感。界面也很清爽，阅读体验一流！',
    rating: 5,
  },
  {
    id: 2,
    name: '星空下的猫',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20anime%20style%20male%20avatar%20portrait%20with%20gentle%20expression%2C%20soft%20illustration%20style%2C%20clean%20minimal%20background&width=80&height=80&seq=avatar-02&orientation=squarish',
    role: '二次元爱好者',
    content: '从贴吧追过来的老粉了，虫虫漫画的更新速度一直很稳定。特别喜欢分类系统，找同类型的漫画很方便，已经安利给身边所有朋友了！',
    rating: 5,
  },
  {
    id: 3,
    name: '樱花落尽',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20anime%20style%20female%20avatar%20portrait%20with%20cute%20expression%2C%20soft%20illustration%20style%2C%20clean%20minimal%20background&width=80&height=80&seq=avatar-03&orientation=squarish',
    role: '漫画创作者',
    content: '作为一名漫画创作者，我非常欣赏虫虫漫画对原创内容的尊重。平台上每一部作品都有明确的版权信息，阅读环境干净整洁，是真正为读者着想的平台。',
    rating: 5,
  },
  {
    id: 4,
    name: '夜行旅人',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20anime%20style%20male%20avatar%20portrait%20with%20cool%20expression%2C%20soft%20illustration%20style%2C%20clean%20minimal%20background&width=80&height=80&seq=avatar-04&orientation=squarish',
    role: 'VIP会员',
    content: '开通会员快一年了，非常值得！每天通勤路上看几话漫画已经成了习惯。希望虫虫能引进更多韩漫作品，尤其是奇幻和悬疑类的！',
    rating: 4,
  },
];